import Text from '../../../../../Text'
import { RentalPortalProvenanceChip } from '../../../../RentalPortalProvenance'

import * as styles from '../RentalPortalListingProfileWidgetAddress.module.css'

function ListingProfileWidgetAddressItem({ children, label, ownership }) {
  return (
    <div className={styles.addressField}>
      <div className={styles.labelRow}>
        <Text isSecondary className={styles.label}>
          {label}
        </Text>
        <RentalPortalProvenanceChip ownership={ownership} />
      </div>
      {children}
    </div>
  )
}

export default ListingProfileWidgetAddressItem
